import { StepImpl } from './steps/step-impl';

export class StepSegment {
  isActive = false;

  get name(): string {
    return this.step.name;
  }

  get text(): string {
    return this.step.text;
  }

  constructor(public readonly step: StepImpl) {}
}
